import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { MatLegacyTableModule as MatTableModule } from "@angular/material/legacy-table";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { TranslateModule } from "@ngx-translate/core";
import { MatCommonModule } from "@obg/mat.ui.common";
import { DialogLayoutModule, MatCoreModule, OverlaySpinnerModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { ObgMatTabsScrollModule } from "@obg/ngx.ui.common";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";

import { LatestTermsAndConditionsContainer } from "../src/latest-terms-and-conditions/latest-terms-and-conditions.container";

import { SmTermsAndConditionsMessage } from "./alert-message/sm-terms-and-conditions-message.container";
import { TermsAndConditionsCurrerntVersionContainer } from "./current-version/terms-and-conditions-currernt-version.container";
import { SmTermsAndConditionsFooterContainer } from "./footer/sm-terms-and-conditions-footer.container";
import { SmTermsAndConditionsHistoryContainer } from "./history/sm-terms-and-conditions-history.container";
import { TermsAndConditionsHistoryContainer } from "./history/terms-and-conditions-history.container";
import { SmTermsAndConditionsContainer } from "./sm-terms-and-conditions.container";
import { TermsAndConditionsModalContainer } from "./terms-and-conditions-modal/terms-and-conditions-modal.container";
import { TermsAndConditionsContainer } from "./terms-and-conditions.container";
import { UpdatedTermsAndConditionsContainer } from "./updated-terms-and-conditions/updated-terms-and-conditions.container";

const DIRECTIVES: any[] = [
	SmTermsAndConditionsContainer,
	SmTermsAndConditionsFooterContainer,
	SmTermsAndConditionsMessage,
	SmTermsAndConditionsHistoryContainer,
	UpdatedTermsAndConditionsContainer,
	TermsAndConditionsContainer,
	TermsAndConditionsHistoryContainer,
	TermsAndConditionsCurrerntVersionContainer,
	TermsAndConditionsModalContainer,
	LatestTermsAndConditionsContainer,
];

@NgModule({
	imports: [
		CommonModule,
		CoreUiModule,
		CoreContentModule,
		MatCoreModule,
		MatCommonModule,
		MatTabsModule,
		RouterModule,
		ObgMatTabsScrollModule,
		MatTableModule,
		MatPaginatorModule,
		DialogLayoutModule,
		OverlaySpinnerModule,
		TranslateModule,
		MatButtonModule,
		MatCheckboxModule,
		ReactiveFormsModule,
		FormsModule,
		MatCardModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class TermsAndConditionsModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, LatestTermsAndConditionsContainer);
	}
}
